import {Types} from "../constants/ServiceActionConstants";
import authService from "../../../auth/AuthService";
import {apiActionsDPService} from "../../../middlewares/veritas-middleware/constants/ApiMiddlewareConstants";
import {resetPDFPortal} from "../../../report-generation/veritas-report-gen/ReportGeneratorActions";

// All Services Actions
const loadAllServices = (services) => ({
    type: Types.LOAD_ALL_SERVICES,
    payload: services
});

const fetchAllDPServices = ({authToken}) => ({
    type: apiActionsDPService.GET_ALL,
    payload: {authToken}
});

const clearServices = () => ({
    type: Types.CLEAR_SERVICES,
});

const selectAllKYCServices = (serviceIds, isSelected) => ({
    type: Types.ALL_KYC_SELECTED,
    payload: { serviceIds, isSelected },
});

const selectSomeKYCServices = (serviceId, isSelected) => ({
    type: Types.SOME_KYC_SELECTED,
    payload: { serviceId, isSelected }
});

export function selectAllKYC(serviceIds, isSelected) {
    return (dispatch) => {
        dispatch(selectAllKYCServices(serviceIds, isSelected))
        dispatch(resetPDFPortal())
    }
}

export function selectSomeKYC(serviceId, isSelected) {
    return (dispatch) => {
        dispatch(selectSomeKYCServices(serviceId, isSelected))
        dispatch(resetPDFPortal())
    }
}


export function clearServicesOnUnmount() {
    return (dispatch) => {
        dispatch(clearServices())
    };
}

export function fetchAllServices() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchAllDPServices({authToken}))
    }
}

export function fetchAllServicesSuccess(services) {
    return (dispatch) => {
        dispatch(loadAllServices(services));
    };
}

// KYC Services Actions
const loadKYCServices = (services) => ({
    type: Types.LOAD_KYC_SERVICES,
    payload: services
});

const fetchAllKYCServices = ({authToken}) => ({
    type: apiActionsDPService.GET_ALL_KYC,
    payload: {authToken}
});

const setKYCFilter = (filterOption, filterType) => ({
    type: Types.SET_KYC_FILTER,
    payload: {filterOption, filterType}
});

const updateKYCListFilter = () => ({
    type: Types.FILTER_KYC_SERVICES,
});

const toggleSortKYC = (sortKey) => ({
    type: Types.TOGGLE_KYC_SORT,
    payload: sortKey
});

const kycGlobalSearch = (value) => ({
    type: Types.KYC_GLOBAL_SEARCH,
    payload: value
})

export function kycTableSearch(value) {
    return (dispatch) => {
        dispatch(kycGlobalSearch(value))
    }
}

const kybGlobalSearch = (value) => ({
    type: Types.KYB_GLOBAL_SEARCH,
    payload: value
})

export function kybTableSearch(value) {
    return (dispatch) => {
        dispatch(kybGlobalSearch(value))
    }
}

export function setKYCServicesFilter(filterOption, filterType){
    return (dispatch) => {
        dispatch(setKYCFilter(filterOption, filterType));
    }
}

export function updateKYCFilters() {
    return (dispatch) => {
        dispatch(updateKYCListFilter())
    };
}

export function fetchKYCServices() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchAllKYCServices({authToken}));
    }
}

export function fetchKYCServicesSuccess(services) {
    return (dispatch) => {
        dispatch(loadKYCServices(services));
    };
}

export function toggleKYCSort(sortKey) {
    return (dispatch) => {
        dispatch(toggleSortKYC(sortKey))
    }
}

// KYB Services Actions
const loadKYBServices = (services) => ({
    type: Types.LOAD_KYB_SERVICES,
    payload: services
});

const fetchAllKYBServices = ({authToken}) => ({
    type: apiActionsDPService.GET_ALL_KYB,
    payload: {authToken}
});

const setKYBFilter = (filterOption, filterType) => ({
    type: Types.SET_KYB_FILTER,
    payload: {filterOption, filterType}
});

const updateKYBListFilter = (filterOption, filterType) => ({
    type: Types.FILTER_KYB_SERVICES,
    payload: {filterOption, filterType}
});

const selectAllKYBServices = (serviceIds, isSelected) => ({
    type: Types.ALL_KYB_SELECTED,
    payload: { serviceIds, isSelected },
});

const selectSomeKYBServices = (serviceId, isSelected) => ({
    type: Types.SOME_KYB_SELECTED,
    payload: { serviceId, isSelected }
});

const toggleSortKYB = (sortKey) => ({
    type: Types.TOGGLE_KYB_SORT,
    payload: sortKey
});

export function selectAllKYB(serviceIds, isSelected) {
    return (dispatch) => {
        dispatch(selectAllKYBServices(serviceIds, isSelected))
        dispatch(resetPDFPortal())
    }
}

export function selectSomeKYB(serviceId, isSelected) {
    return (dispatch) => {
        dispatch(selectSomeKYBServices(serviceId, isSelected))
        dispatch(resetPDFPortal())
    }
}


export function setKYBServicesFilter(filterOption, filterType){
    return (dispatch) => {
        dispatch(setKYBFilter(filterOption, filterType));
    }
}

export function updateKYBFilters() {
    return (dispatch) => {
        dispatch(updateKYBListFilter())
    };
}

export function fetchKYBServices() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchAllKYBServices({authToken}))
    }
}

export function fetchKYBServicesSuccess(services) {
    return (dispatch) => {
        dispatch(loadKYBServices(services));
    };
}


export function toggleKYBSort(sortKey) {
    return (dispatch) => {
        dispatch(toggleSortKYB(sortKey))
    }
}

const types = {
    Types,
}

export default types;